/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { enqueueSnackbar, type SnackbarOrigin } from 'notistack';

type DisplayToastArgs = {
	message: string;
	location?: 'top' | 'left';
	variant?: 'success' | 'warning' | 'error' | 'info';
};

export function displayToast( { message, location = 'top', variant = 'success' }: DisplayToastArgs ): string | number {
	const anchorOrigin: SnackbarOrigin = location === 'top' ?
		{ vertical: 'top', horizontal: 'center' } :
		{ vertical: 'bottom', horizontal: 'left' };

	return enqueueSnackbar( message, { anchorOrigin, variant } );
}
